"use strict";import{IconDash75 as e}from"../src/elements/IconDash75.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-icon-dash75",e);
//# sourceMappingURL=sp-icon-dash75.js.map
